<template>
  <div class="level-remain-dialog">
    <el-dialog
      :title="$t('member.tab.memberInfo.levelRemainTitle')"
      :visible="show"
      width="570px"
      :close-on-click-modal="false"
      @close="$emit('update:show', false)"
    >
      <div>
        <div class="pb-[20px]">
          {{ $t('member.tab.memberInfo.levelRemainCondition') }}{{ displayRemainCondition }}
        </div>
        <BaseElSelect v-model="levelRemain" @change="changeRemain">
          <BaseElSelectOption :label="$t('member.tab.memberInfo.levelRemainFulfilled')" :value="true" />
          <BaseElSelectOption :label="$t('member.tab.memberInfo.levelRemainNotFulfilled')" :value="false" />
        </BaseElSelect>
        <div class="py-[20px]">
          {{ $t('member.tab.memberInfo.levelRemainWarning') }}
        </div>
        <div class="btn-container">
          <BaseElButton
            style="width: 140px"
            plain
            @click="$emit('update:show', false)"
          >
            {{ $t('member.tab.memberInfo.cancel') }}
          </BaseElButton>
          <BaseElButton style="width: 140px" type="primary" @click="confirm">
            {{ $t('member.tab.memberInfo.confirm') }}
          </BaseElButton>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import { get } from 'lodash'
import { conditionOptionsConfig } from '@/config/memberLevel'
import { t } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'LevelRemainDialog',
  props: ['show', 'isLevelRemainFulfilled', 'levelConfig'],
  setup (props, { emit }) {
    const levelRemain = ref(props.isLevelRemainFulfilled)

    const displayRemainCondition = computed(() => {
      const levelRemainCondition = get(props.levelConfig, 'levelRemainCondition')
      const levelRemainPeriod = get(props.levelConfig, 'levelRemainPeriod')
      const levelRemainThreshold = get(props.levelConfig, 'levelRemainThreshold')

      if (levelRemainCondition === conditionOptionsConfig.periodAmount.value) {
        return t('member.tab.memberInfo.levelRemainPeriodAmount', { period: levelRemainPeriod, amount: levelRemainThreshold })
      } else if (levelRemainCondition === conditionOptionsConfig.periodCount.value) {
        return t('member.tab.memberInfo.levelRemainPeriodCount', { period: levelRemainPeriod, count: levelRemainThreshold })
      }
      return t('member.tab.memberInfo.levelRemainOnce', { amount: levelRemainThreshold })
    })

    const changeRemain = (e) => {
      levelRemain.value = e
    }

    const confirm = () => {
      emit('update:isLevelRemainFulfilled', levelRemain.value)
      emit('update:show', false)
    }
    return {
      levelRemain,
      changeRemain,
      confirm,
      displayRemainCondition,
    }
  },
})
</script>

<style lang="postcss" scoped>
.btn-container {
  @apply flex justify-end;
}
</style>
